import axiosPost from '../axiosPost';

export const tarjetasMarcasGet = async (arg) => {
    const body = {
        "service": "GWCardMarcaGet",
        "params": {}
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
}